<div class="select-city">
  <div class="regions">
    <div class="region" *ngFor="let region of regions" [ngClass]="regionClasses(region)" (click)="setRegion(region)">
      {{region.name}}
    </div>
  </div>
  <div class="cities">
    <div class="cities_search">
      <div class="cities_search_input">
        <input type="text" placeholder="Поиск города"  [(ngModel)]="search" (keyup)="filterCities()"  />
      </div>
    </div>
    <div class="cities_list">
      <div class="city" *ngFor="let city of cities" (click)="setCity(city)" [ngClass]="city.active ? 'active' : ''">{{city.name}}</div>
    </div>
  </div>
</div>
